export const HTTP_200_OK = 200;
export const HTTP_404_NOT_FOUND = 404;
export const HTTP_413_REQUEST_ENTITY_TOO_LARGE = 413;
